import type { IVehicle } from '@makemydeal/dr-platform-types';

export const isValidVehicle = (vehicle: IVehicle): boolean => {
    const sellingPrice = vehicle.listedPrice;
    const msrpPrice = vehicle.retailPrice;
    const mileage = vehicle.mileage;

    const isNewVehicle = vehicle.condition === 'new';
    const minMileageValue = isNewVehicle ? 0 : 1;

    const hasValidSellingPrice = typeof sellingPrice === 'number' && sellingPrice > 0;
    const hasValidMSRPPrice = !isNewVehicle || (typeof msrpPrice === 'number' && msrpPrice > 0);
    const hasValidMileage = typeof mileage === 'number' && mileage >= minMileageValue;

    return !!hasValidSellingPrice && !!hasValidMSRPPrice && !!hasValidMileage;
};
